export enum ERole{
    SUPER_ADMIN = "super_admin",
    SUB_ADMIN = "sub_admin",
    EMPLOYER = "employer",
    TEAM_MEMBER = "team_member",
    TEAM_MANAGER = "team_manager"
}
